import { ShieldCheck } from 'lucide-react';

/**
 * Shared notice for all `/tools/crypto/*` pages reminding users that
 * cryptographic computation runs entirely in the browser tab.
 *
 * Kept stateless and dependency-free so any future crypto tool (HMAC,
 * AES, RSA, JWT decode/sign, ...) can drop it in with zero wiring.
 */
export function CryptoPrivacyBanner(): JSX.Element {
  return (
    <aside className="flex items-start gap-2 rounded-md border border-emerald-300/40 bg-emerald-50/50 px-3 py-2 text-[12px] text-emerald-900 dark:border-emerald-700/40 dark:bg-emerald-950/40 dark:text-emerald-200">
      <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="leading-relaxed">
        <strong className="font-semibold">所有运算都在你的浏览器内进行。</strong>
        <span className="text-emerald-800/90 dark:text-emerald-300/90">
          {' '}
          密钥、消息、Token 不会离开你的设备，关闭页面后即清空，无任何持久化或上传。
        </span>
      </div>
    </aside>
  );
}
